module.exports = __webpack_public_path__ + "img/logo-42x28.89e8fc3f.svg";